import useEventListener from './useEventListener';

export default useEventListener;
